import { Component, OnInit } from '@angular/core';
import { FvrZeropaySupportPopupService } from '../zeropay-support/fvr-zeropay-support-popup.service';

@Component({
  selector: 'app-account-deletion',
  templateUrl: './account-deletion.component.html',
  styleUrls: ['./account-deletion.component.scss'],
})
export class AccountDeletionComponent implements OnInit {
  constructor(private supportService: FvrZeropaySupportPopupService) {}

  ngOnInit(): void {
    /* */
  }

  showContact() {
    this.supportService.showContactDialog();
  }
}
